var map = {
	"./Action.jpg": 55541,
	"./All.jpg": 1931,
	"./Amazon.jpg": 68684,
	"./Animation.jpg": 93185,
	"./Anime.jpg": 85787,
	"./Comedy.jpg": 92938,
	"./Crime.jpg": 74318,
	"./Discovery-Plus.jpg": 26634,
	"./Disney.jpg": 27219,
	"./Documentary.jpg": 88018,
	"./Drama.jpg": 93396,
	"./Family.jpg": 4810,
	"./Fantasy.jpg": 9318,
	"./HBO.jpg": 22226,
	"./Highest-Rated.jpg": 47949,
	"./History.jpg": 45467,
	"./Horror.jpg": 9173,
	"./In-Theaters.jpg": 38533,
	"./Most-Popular.jpg": 60137,
	"./Most-Voted.jpg": 10099,
	"./Music.jpg": 68708,
	"./Mystery.jpg": 88297,
	"./Netflix.jpg": 28102,
	"./Oscars-Winning.jpg": 72361,
	"./Recent-Added.jpg": 33441,
	"./Romance.jpg": 24479,
	"./Sci-Fi.jpg": 55270,
	"./Thriller.jpg": 16143,
	"./Top-Grossing.jpg": 87265,
	"./Trending.jpg": 96664,
	"./Western.jpg": 89648,
	"./Year-2017.jpg": 31804,
	"./Year-2018.jpg": 49899,
	"./Year-2019.jpg": 36923,
	"./Year-2020.jpg": 18134,
	"./Year-2021.jpg": 62799,
	"./Year-2022.jpg": 8742,
	"./Year-2023.jpg": 76734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3992;